import type { LivePhase, SourceStatus } from '../../shared/race';

const labels: Record<LivePhase, string> = {
  unconfigured: '实时未配置', connecting: '正在连接', waiting: '已连接 · 待赛',
  streaming: '实时数据', recovering: '正在恢复连接', stale: '数据陈旧', error: '连接失败', ended: '场次结束',
};

/** Presentation consumes the source contract, never transport packets as evidence of fresh data. */
export function presentLiveStatus(status: SourceStatus, now: number) {
  const last = status.lastEventAt ? Date.parse(status.lastEventAt) : NaN;
  let phase: LivePhase;
  if (!status.configured) phase = 'unconfigured';
  else if (status.phase === 'error') phase = 'error';
  else if (status.phase === 'ended') phase = 'ended';
  else if (!status.connected) phase = 'connecting';
  else if (status.recovering || status.phase === 'recovering') phase = 'recovering';
  else if (status.phase === 'waiting') phase = status.phase;
  else if (!Number.isFinite(last)) phase = 'waiting';
  else if (now - last > 30_000) phase = 'stale';
  else phase = status.phase === 'stale' ? 'stale' : 'streaming';
  return { phase, label: labels[phase], stale: !['streaming', 'ended'].includes(phase) };
}
